module.exports = __webpack_public_path__ + "img/stock3.734a8388.png";